import React from 'react';
import { BaseRouterLink, BaseRouterLinkProps } from './BaseRouterLink';

export type SubtleRouterLinkProps = Omit<BaseRouterLinkProps, 'color' | 'size'>;

export function SubtleRouterLink({ children, ...props }: SubtleRouterLinkProps) {
    return (
        <BaseRouterLink {...props} color="fiftyFirstShade" size="subtle">
            {children}
        </BaseRouterLink>
    );
}
